module.exports = __webpack_public_path__ + "img/jg3.90e31519.png";